
    import React, { Fragment } from 'react';
    
    
    const Markdown = () => (<Fragment><p>Thanks for registering for the 2021 SciDAS Cloud Computing Workshop in Chapel Hill December 6-7, 2021. Your registration indicates that you plan to attend the workshop in-person. Clemson University is able to reimburse in-person attendees up to $500 per person for travel expenses *, including but not limited to: mileage, hotel, economy airline or economy train tickets, rental car and hotel shuttle.**</p>
<p>NOTE, Clemson University is unable to reimburse expenses to and from the airport for Uber, Lyft, or Taxi service.**</p>
<h2 id="-instructions-for-reimbursement">* Instructions for Reimbursement</h2>
<ul>
<li>All requests to Clemson University for reimbursement must be submitted no later than Friday, December 10, 2021. </li>
<li>All receipts can be received as electronic invoices &#40;snap a photo of the original receipt with the camera on your phone, for example&#41;. </li>
<li>If you are requesting reimbursement for mileage, hotel stay&#40;s&#41;, economy airline or economy train tickets, rental car or hotel shuttle: </li>
</ul>
<ol>
<li><p>All reimbursement requests </p>
<blockquote>
<p>Email Elizabeth Brown &#40;<a href="emb5@clemson.edu">emb5@clemson.edu</a>&#41; the following information:</p>
</blockquote>
<ul>
<li>First and Last Name</li>
<li>Email Address</li>
<li>Phone number</li>
</ul>
</li>
<li><p>Gas Mileage Only </p>
</li>
</ol>
<p>If you are requesting reimbursement for gas mileage only, the email to Elizabeth should also include the COMPLETED </p>
<ol>
<li><p>Visitor and Guest travel form for Clemson &#40;form attached&#41;</p>
</li>
<li><p>GSA standard mileage form &#40;form attached&#41;</p>
</li>
<li><p>Gas Mileage and Hotel </p>
</li>
</ol>
<p>If you are requesting reimbursement for gas mileage and hotel, the email to Elizabeth should include the COMPLETED </p>
<ol>
<li><p>Visitor and Guest travel form for Clemson &#40;form attached&#41;</p>
</li>
<li><p>GSA standard mileage form &#40;form attached&#41;</p>
<p><strong>AND</strong></p>
</li>
<li><p>Digital copy of the hotel receipt that includes: </p>
</li>
</ol>
<ul>
<li>Total charges for nights stayed </li>
<li>Parking charges 
<em>Food and beverage charges incurred at the hotel cannot be included on receipt and will not be reimbursed</em>.</li>
</ul>
<ol>
<li><p>Gas Mileage, Hotel and Airfare or Train Travel</p>
</li>
<li><p>If you are requesting <em>reimbursement for gas mileage, hotel and airfare or train travel</em>, the email to Elizabeth should include the COMPLETED</p>
</li>
<li><p>Visitor and Guest travel form for Clemson &#40;form attached&#41;</p>
</li>
<li><p>GSA standard mileage form &#40;form attached&#41;</p>
<p><strong>AND</strong></p>
</li>
<li><p>Digital copy of the hotel receipt that includes: </p>
</li>
</ol>
<ul>
<li><p>Total charges for nights stayed </p>
</li>
<li><p>Parking charges 
<em>Food and beverage charges incurred at the hotel cannot be included on receipt and will not be reimbursed</em>.</p>
<p><strong>AND</strong></p>
</li>
</ul>
<p>Digital copy of the <strong>ECONOMY</strong> airline or train ticket; main cabin, comfort plus, business, etc. cannot be included on the receipt and will not be reimbursed. </p>
<ul>
<li>Include flight number and dates, flight details
<em>Food and beverage charges incurred at the hotel cannot be included on receipt and will not be reimbursed</em>.</li>
</ul>
<ol>
<li>Rental Car</li>
</ol>
<p>If you are requesting reimbursement for a rental car, the email to Elizabeth should include the COMPLETED</p>
<ol>
<li><p>Visitor and Guest travel form for Clemson &#40;form attached&#41;</p>
</li>
<li><p>GSA standard mileage form &#40;form attached&#41;</p>
<p><strong>AND</strong></p>
</li>
<li><p>Digital copy of the rental car receipt that includes: </p>
</li>
</ol>
<ul>
<li>Total charges for days rented </li>
<li>Parking charges </li>
</ul>
<ol start="2">
<li>Digital copies of fuel receipts</li>
</ol>
<h2 id="-airport-shuttle">** Airport Shuttle</h2>
<p>If you are requesting <em>reimbursement for an airport shuttle, please note that Clemson will reimburse charges for an airport shuttle but it WILL NOT REIMBURSE CHARGES FOR LYFT, UBER, OR A TAXI</em>. The email to Elizabeth should include the COMPLETED</p>
<ol>
<li><p>Visitor and Guest travel form for Clemson &#40;form attached&#41;</p>
</li>
<li><p>GSA standard mileage form &#40;form attached&#41;</p>
<p><strong>AND</strong></p>
</li>
<li><p>Digital copy of the airport shuttle receipt that includes:</p>
</li>
</ol>
<ul>
<li>Total charge for the pick up to and from local airport</li>
</ul>
<h2 id="questions-contact-information">Questions? Contact Information</h2>
<p>Email Elizabeth Bowman <a href="emb5@clemson.edu">emb5@clemson.edu</a> with additional reimbursement or travel expense questions you may have. </p>
<p>Email Amanda Miller <a href="amiller@renci.org">amiller@renci.org</a> with questions you have about the Courtyard Chapel Hill accommodations or the event venue, the Friday Center.</p>
</Fragment>);
    export default Markdown;
  